// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page.error[data-v-4593edba]{align-items:center;background:#fff;display:flex;min-height:calc(80vh - 92px)}.page.error .wrapper[data-v-4593edba]{flex:1}.page.error .actions[data-v-4593edba]{text-align:center}.page.error .actions>*[data-v-4593edba]{margin:.25em .75em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
